@if (slides().length) {
    <sirius-slider
        [loop]="true"
        layout="fluid"
        [startIndex]="0"
        [showArrows]="showArrows()"
        [showDots]="showDots()"
        (selectedIndex)="onSlideChange($event)">
        @for (slide of slides(); track $index) {
            <sirius-hero-v3-slide
                [backgroundImage]="slide.backgroundImage"
                [backgroundImageMobile]="slide.backgroundImageMobile"
                [backgroundVideoUrl]="slide.backgroundVideoUrl"
                [showVideoOnMobile]="slide.showVideoOnMobile"
                [eyebrow]="slide.eyebrow"
                [title]="slide.title"
                [subTitle]="slide.subTitle"
                [buttonPrimary]="slide.buttonPrimary"
                [buttonSecondary]="slide.buttonSecondary"
                [contentAlignment]="slide.contentAlignment"
                [isActive]="currentIndex() === $index" />
        }
    </sirius-slider>
}
